import { ReactNode } from "react";
import VideoPlayingBar from "./VideoPlayingBar";

const PlayListChip = ({ icon, text, isPlay = false }: { icon?: ReactNode; text: string; isPlay?: boolean }) => {
  return (
    <div className="absolute bottom-1 right-1 flex items-center justify-center bg-slate-800/70 p-1 px-2  rounded-sm z-10">
      {icon && <span>{icon}</span>}
      {isPlay ? <VideoPlayingBar /> : <span className="text-white text-xs font-semibold body_text_m -mt-0.5">{text}</span>}
    </div>
  );
};

export default PlayListChip;
